import ContractForm from '../screens/ContractFrom'
import ContractTabs from '../screens/Contracts'
import TemplateForm from '../screens/TemplateFrom'
import { ROLE, RouteWithAccessType } from './types'

const contractPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/contracts/(list|templates)',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    requiredFeatures: ['contract.list.view', 'template.list.view'],
    component: <ContractTabs />,
    // Same defect as the policies route: with no tabs declared, canAccessTab finds no
    // tabConfig and returns false, so ContractTabs redirected everyone to /403 — a route
    // that did not exist — and the page rendered blank. One feature per tab, split from
    // the two the route already requires.
    // The role lists below are INERT today: canAccessTab reads only requiredFeatures.
    // They are populated anyway because their absence is the same shape as the bug this
    // fixes — if a guard ever starts reading tab roles, a tab with none would deny
    // everyone. They mirror the route's own lists exactly, so they widen nothing.
    tabs: [
      {
        params: { page: 'list' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        requiredFeatures: ['contract.list.view']
      },
      {
        params: { page: 'templates' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        requiredFeatures: ['template.list.view']
      }
    ],
    sections: {
      ADD_CONTRACT_BUTTON: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        requiredFeatures: ['contract.create']
      },
      ADD_TEMPLATE_BUTTON: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING
        ],
        requiredFeatures: ['template.create']
      },
      PROVIDER_SELECTOR: {
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN]
        // requiredFeatures: ['contract.list.view', 'template.list.view']
      }
    }
  },
  {
    route: '/contracts/list/create',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    requiredFeatures: ['contract.create'],
    component: <ContractForm />
  },
  {
    route:
      '/contracts/provider/:providercode/:providerID/template/:templateID/contract/:ID',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    requiredFeatures: ['contract.details.view', 'contract.edit'],
    component: <ContractForm />
  },
  {
    route: '/templates/list/create',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    requiredFeatures: ['template.create'],
    component: <TemplateForm />
  },
  {
    route: '/templates/provider/:providerCode/template/:templateID',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    requiredFeatures: ['template.details.view', 'template.edit'],
    component: <TemplateForm />
  }
]

export default contractPagesRoleManagement
